$(document).on('turbolinks:load', function () {
    initializeSelect2Tags();
});

$(document).on('ajax:success', function() {
    initializeSelect2Tags();
});

$(document).on('shown.bs.modal', '.modal', function() {
    $(this).find('.select2-tags').each(function() {
        if ($(this).data('select2')) {
            $(this).select2('destroy');
        }
        $(this).select2({
            tags: true,
            tokenSeparators: [','],
            dropdownParent: $(this).closest('.modal')
        });
    });
});

function initializeSelect2Tags() {
    $('.select2-tags').each(function() {
        if (!$(this).data('select2')) {
            $(this).select2({
                tags: true,
                tokenSeparators: [','],
                dropdownParent: $(this).closest('.modal').length > 0 ? $(this).closest('.modal') : $(document.body)
            });
        }
    });
}
